import React from 'react';
import styled from 'styled-components';

import OtpForm from './OtpForm';

const P = styled.p`

`;

export default () => (
  <OtpForm title="Register" altLink={{ to: 'Login', text: 'Login' }}>
    <P>Register to gain access to daily email updates for items you're interested in.</P>
    <P>Once you sign up, you'll be able to pick and choose the keywords you want to follow</P>
    <P>We'll only send you one email a day, and won't sell or provide your information to any other parties</P>
  </OtpForm>
);



// WEBPACK FOOTER //
// ./src/auth/Register.js